define('Independent.IndividualPopup.View',
[
    'independent_individualpopup.tpl',
    'underscore',
    'Backbone'
],
function (independent_individualpopup_tpl,
          _,
          Backbone) {

    'use strict';

    return Backbone.View.extend({


        template: independent_individualpopup_tpl,

         initialize: function (options) {
        }

        , getContext: function () {
            return {
            };
        }

    })
})
